import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, Popup, UiButton } from '@shared/ui';
import { Loader } from '@shared/ui/CustomModal/ui/Loader/Loader';

import { ModalBodyShowManagerInfo } from './ModalBodyShowManagerInfo/ModalBodyShowManagerInfo';
import cls from './ModalShowManagerInfo.module.css';
import { useModalShowManagerInfo } from './useModalShowManagerInfo';
import { Icon } from '../../../../components/newUI/Icon/Icon';

interface ModalShowManagerInfoProps {
    classes?: string;
}

export const ModalShowManagerInfo = ({ classes }: ModalShowManagerInfoProps) => {
    const {
        modalMode,
        onCancel,
        onClickEditMode,
        modalLoader,
        managerInfo,
        onDelete,
        is_customer,
        can_show_financial_info,
        isShowPopup,
        onHidePopup,
        onShowPopup,
    } = useModalShowManagerInfo();
    const { t } = useTranslation();

    return (
        <>
            <Popup
                isOpen={isShowPopup}
                onHidePopup={onHidePopup}
                btnActionCb={onDelete}
                type="delete"
                deleteButtonText={t('ModalShowManagerInfo.return.popup.danger')}
                cancelButtonText={t('ModalShowManagerInfo.return.popup.cancel')}
                popupContentClassName={cls.secondModal}
                contentText={t('ModalShowManagerInfo.return.popup.text')}
            />

            <CustomModal
                contentClasses={cls.ModalContainer}
                isOpen={modalMode === 'showManagerInfo'}
                onHideModal={onCancel}
            >
                {modalLoader && <Loader variant="light" />}
                <CustomModal.Header>
                    <Flex gap={12} className={cls.headerWrapper}>
                        {t('ModalShowManagerInfo.return.modalHeader.title')}
                        {
                            // @ts-ignore
                            !is_customer && can_show_financial_info && (
                                <UiButton
                                    className={cls.hederButton}
                                    onClick={onClickEditMode}
                                    variant="icon"
                                    startIcon={<Icon iconName="editInformationBlock" />}
                                />
                            )
                        }
                    </Flex>
                </CustomModal.Header>
                <CustomModal.Body>
                    <ModalBodyShowManagerInfo managerInfo={managerInfo} />
                </CustomModal.Body>
                <CustomModal.Footer>
                    <Flex fullWidth justify="between">
                        {
                            // @ts-ignore
                            !is_customer && can_show_financial_info && (
                                <UiButton
                                    btnText={t('ModalShowManagerInfo.return.modalFooter.delete')}
                                    onClick={onShowPopup}
                                    btnColor="danger"
                                />
                            )
                        }
                        <UiButton
                            btnColor="secondary"
                            btnText={t('ModalShowManagerInfo.return.modalFooter.close')}
                            onClick={onCancel}
                        />
                    </Flex>
                </CustomModal.Footer>
            </CustomModal>
        </>
    );
};
